"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _ToggleModule = _interopRequireDefault(require("./Toggle.module.scss"));

var _excluded = ["isActive", "className", "IconActive", "IconNotActive", "disabled", "onClick"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Toggle = function Toggle(_ref) {
  var isActive = _ref.isActive,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      IconActive = _ref.IconActive,
      IconNotActive = _ref.IconNotActive,
      disabled = _ref.disabled,
      _ref$onClick = _ref.onClick,
      onToggleClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: (0, _classnames["default"])(_ToggleModule["default"].toggle, isActive && _ToggleModule["default"].active, disabled && _ToggleModule["default"].disabled, className),
    onClick: function onClick() {
      return disabled ? {} : onToggleClick();
    }
  }, props), IconActive ? /*#__PURE__*/_react["default"].createElement(IconActive, {
    className: (0, _classnames["default"])(_ToggleModule["default"].icon, _ToggleModule["default"].icon__active)
  }) : /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    type: "checkmark",
    className: (0, _classnames["default"])(_ToggleModule["default"].icon, _ToggleModule["default"].icon__active)
  }), IconNotActive ? /*#__PURE__*/_react["default"].createElement(IconNotActive, {
    className: (0, _classnames["default"])(_ToggleModule["default"].icon, _ToggleModule["default"].icon__notActive)
  }) : /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    type: "close-small",
    className: (0, _classnames["default"])(_ToggleModule["default"].icon, _ToggleModule["default"].icon__notActive)
  }));
};

var _default = Toggle;
exports["default"] = _default;